import React from "react";
import { BrowserRouter, HashRouter } from 'react-router-dom';
import AppRouter from "./router/AppRouter";
import { PosterCategoriesProvider } from "./context/PosterCategories";
import { CityProvider } from "./context/City";
import { AuthProvider } from "./hooks/useAuth";
function App() {
   return (
      <div>
         <BrowserRouter>
            <AuthProvider>
               <CityProvider>
                  <PosterCategoriesProvider>
                     <AppRouter />
                  </PosterCategoriesProvider>
               </CityProvider>
            </AuthProvider>
         </BrowserRouter>
      </div>
   );
}

export default App;

